import { useState } from 'react';

export const useRenameSwarmSession = (API_URL) => {
  const [isRenaming, setIsRenaming] = useState(false);

  const renameSwarmSession = async (sessionId, name) => {
    if (!API_URL || !sessionId || !name?.trim()) return false;
    setIsRenaming(true);
    try {
      const response = await fetch(`${API_URL}/swarm/sessions/rename`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ session_id: sessionId, name: name.trim() }),
      });
      if (!response.ok) throw new Error(`HTTP error ${response.status}`);
      return true;
    } catch (error) {
      console.error('Error renaming swarm session:', sessionId, error);
      return false;
    } finally {
      setIsRenaming(false);
    }
  };

  return { renameSwarmSession, isRenaming };
};
